import {CancellationType} from '../CancellationType'
import {EmailData} from './EmailData'

export type CancellationEmailData = EmailData & {
    cancellationType: CancellationType
}
